<template>
  <div
    v-loading="!foreigner"
    class="tw-min-h-screen"
  >
    <template v-if="foreigner">
      <ForeignersHeader
        :tab="tab"
        @change-tab="changeTab"
      />

      <div class="tw-border-t tw-border-gray dark:tw-border-dm-gray">
        <ForeignersBasicInfo
          v-if="tab === 'info'"
        />

        <V2ForeignersPermits
          v-if="tab === 'permits'"
        />

        <ForeignersQuestionnaires
          v-if="tab === 'questionnaires'"
        />

        <ForeignersLogs
          v-if="tab === 'logs'"
        />
      </div>

      <ForeignersMessagingPopover />
    </template>
  </div>
</template>

<script>
import ForeignersHeader from '@/components/Foreigners/ForeignersHeader.vue';
import ForeignersBasicInfo from '@/components/Foreigners/BasicInfo/ForeignersBasicInfo.vue';
import V2ForeignersPermits from '@/components/Foreigners/Permits/ForeignersPermits.vue';
import ForeignersLogs from '@/components/Foreigners/Logs/ForeignersLogs.vue';
import ForeignersMessagingPopover from '@/components/Foreigners/Messaging/ForeignersMessagingPopover.vue';
import ForeignersQuestionnaires from '@/components/Foreigners/Questionnaires/ForeignersQuestionnaires.vue';
import { mapState } from 'vuex';

export default {
  name: 'Foreigner',

  components: {
    ForeignersQuestionnaires,
    ForeignersHeader,
    ForeignersBasicInfo,
    V2ForeignersPermits,
    ForeignersLogs,
    ForeignersMessagingPopover,
  },

  data() {
    return {
      tab: 'permits',
    };
  },

  computed: {
    ...mapState({
      foreigner: (state) => state.v2.admin.foreigners.foreigner.foreigner,
    }),
  },

  mounted() {
    this.$store.commit('v2/admin/foreigners/foreigner/set', ['foreigner', null]);
    this.$store.dispatch('v2/admin/foreigners/foreigner/loadForeignerDetail', this.$route.params.fid);
    this.$store.dispatch('v2/admin/foreigners/foreigner/loadPermits', this.$route.params.fid);

    const pathname = window.location.pathname;

    // This regex captures a path starting with foreigners/, followed by one or more non-slash characters (foreignerId),
    // then optionally another segment comprising one or more non-slash characters (tab name),
    // and finally it optionally captures another numeric segment (optional id dependent on what tab is selected).
    const match = pathname.match(/foreigners\/([^\/]+)(?:\/([^\/]+))?(?:\/(\d+))?/i);

    if (match) {
      if (match[2]) { // If there is a tab in the URL, it will be in the second capturing group
        this.tab = match[2];
      }
    }
  },
  unmounted() {
    this.$store.commit('v2/admin/foreigners/foreigner/set', ['foreigner', null]);
  },

  methods: {
    changeTab(tab) {
      this.tab = tab;
      const baseUrl = window.location.origin;
      const foreignerId = window.location.pathname.split('/')[2];

      let newUrl = `${baseUrl}/foreigners/${foreignerId}`;

      if (tab) {
        newUrl += `/${tab}`;
      }

      window.history.pushState({}, '', newUrl);
    },
  },
};
</script>
